<template>
  <DisplayContainer label="GU Nutzerverwaltung Bau Backoffice">
    <v-tabs
      v-model="tab"
      background-color="transparent"
    >
      <v-tab
        key="manage-user"
        to="#manage-user"
      >
        Benutzer verwalten
      </v-tab>
      <v-tab
        key="companies"
        to="#companies"
      >
        GU Firmen
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="manage-user">
        <v-card>
          <v-card-text>
            <div class="manage-wrapper py-8">
              <ConstructionAccountManage
                ref="manageView"
                :companies="companies"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="companies">
        <v-card>
          <v-card-text>
            <div class="companies-wrapper py-8">
              <ConstructionCompanyManage
                ref="guCompanyView"
                :companies="companies"
                :companiesLoading="companiesLoading"
                @update-companies="updateCompanies"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </DisplayContainer>
</template>

<script>
import { orderBy } from 'lodash';
import { HTTP } from '@/main/httpClient';
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
import { showNotification } from '@/main/NotificationObject.js';

export default {
  name: 'ConstructionAccountManager',
  components: {
    DisplayContainer,
    ConstructionAccountManage: () =>
      import('@/views/externalAccount/ConstructionAccountManage'),
    ConstructionCompanyManage: () =>
      import('@/views/externalAccount/ConstructionCompanyManage')
  },
  data: () => ({
    tab: null,
    loading: true,
    companiesLoading: false,
    companies: []
  }),
  async mounted() {
    this.updateCompanies();
  },
  methods: {
    async updateCompanies() {
      this.companies = orderBy(
        (await this.fetchCompanies()) ?? [],
        ['name'],
        ['asc']
      );
    },
    fetchCompanies() {
      this.companiesLoading = true;
      return HTTP.get('/past/companies')
        .then(({ status, data }) => {
          if (status !== 200) {
            showNotification('Fehler beim laden der Firmen', 'warning');
          } else return data;
        })
        .catch(() => {
          showNotification('Fehler beim laden der Firmen', 'error');
        })
        .finally(() => {
          this.companiesLoading = false;
        });
    }
  }
};
</script>
